import React from "react";
import Questions_Table_IPAQ from "./table";
import { Container } from "react-bootstrap";
import ipaq from "./data.json"; // your JSON file with the extracted questions

class IPAQ extends React.Component {
  constructor(props) {
    super();
    this.state = {};
  }

  handleTableChange = async (newState) => {
    await this.setState({ ...newState });
    if (this.props.handler) {
      this.props.handler("ipaq", this.state);
    }
  };

  async componentDidMount() {
    if (this.props.data) {
      await this.setState(this.props.data);
    }
  }

  render() {
    return (
      <Container>
        <Questions_Table_IPAQ
          questions={ipaq}
          data={this.props.data || {}}
          handler={this.handleTableChange}
          disabled={this.props.disabled}
        />
      </Container>
    );
  }
}

export default IPAQ;

IPAQ.defaultProps = {
  handler: null,
  disabled: false,
};
